// extracted by mini-css-extract-plugin
export default {"productCharacteristics__title":"styles_product-characteristics__title__zHauz","productCharacteristics__barcodes":"styles_product-characteristics__barcodes__aRmEx"};